<template>
  <div class="popup-new features new" data-popup="popup-1" id="remove_words_features_popup" >
    <div class="popup-inner">
      <!--CLOSE EVENT-->
      <a @click="featuresToShow=[]" class="popup-close" data-toggle="modal" data-target="#remove_words_features_popup" href="#"><img src="../../assets/cross.png"></a>
      <!-- (this version of the next line caused bugs) <div class="wrap-popup" style="overflow: hidden; height: 100%;"> -->
      <div class="wrap-popup" style="height: 100%;">
        <!--SLIDE CONTENT Examples of "×¢×œ"-->
        <div id="features-show" style="display: none;" class="tile">
          <div class="back-arrow __web-inspector-hide-shortcut__" @click="showPopup('close', null)">
            <a href="#"><img src="../../assets/ic_back.png"></a>
          </div>
          <feature-examples v-bind:feature="chosenFeature"></feature-examples>
        </div>
        <!--Classes View / Remove words and features INNER CONTENT-->
        <div id="features-hide">
          <div class="txt-box">
            <div class="img-txt">
              <img src="../../assets/Lowercase-Outline-white.png">
              <h2 class="white"><strong>Classes:</strong> View and edit features</h2> <!-- (for debugging) v-on:click="logFeaturesToInclude" -->
              <div class="i-doc white float-left"><i class="fas fa-info-circle fa-lg" @click="openHelpTab"></i></div>
            </div>
          </div>
          <div class="popup-holder" style="overflow: initial">
            <!-- Start Nav tabs -->
            <div class="new-style">
              <a class="bt-slideDown" href="#" @click="showNav = !showNav">
                <h3 class="f blue"><i v-show="showNav" class="fa fa-angle-double-up" aria-hidden="true"></i><i v-show="!showNav" class="fa fa-angle-double-down" aria-hidden="true"></i> Active Categories (<span style="color: #007EE5" v-for="(activeCat, activeCat_index) in activeCats" :key="activeCat_index"><span style="color: #007EE5" v-show="activeCat_index !== 0">, </span>{{ activeCat }}</span>)</h3>
              </a>
              <transition name="fade">
                <div v-show="showNav">
                  <ul class="nav-link nav nav-tabs checktab">
                    <li v-for="featureSetKey in allFeatureSets" :key="featureSetKey"> <!-- :class="{active: focusedSet === featureSetKey}"> -->
                      <a class="tab-a"> <!-- @click="focusedSet = featureSetKey"> -->
                        <label class="control control--checkbox feature-tab-checkbox">
                          <div class="chek-box-holder">
                            <input type="checkbox" v-bind:checked="activeFeatureSets[featureSetKey]">
                            <div @click="toggleSet(featureSetKey)" class="control__indicator"></div>
                          </div>
                        </label>
                        <h3 class="feature-tab-heading">{{ setDisplayName[featureSetKey] }}</h3>
                      </a>
                    </li>
                  </ul>
                </div>
              </transition>
            </div>
            <!-- End Nav tabs -->
            <div class="baron" v-infinite-scroll="loadMore" infinite-scroll-disabled="infiniteScrollProps.busy" infinite-scroll-distance="10">
              <div id="scrollable26" style="padding-bottom: 0;" class="baron__scroller">
                <div class="tab-content tab-content2" style="padding: 0;"> <!-- v-bind:class="[!(activeFeatureSets[focusedSet]) ? 'dimmed'  : '']" -->
                  <div
                     role="tabpanel" class="tab-pane active">
                    <table class="addstyle">
                      <thead>
                      <tr>
                        <th class="col">
                          <label class="control control--checkbox" :class="{uncheck: someChecked}">
                            <div class="chek-box-holder">
                              <input type="checkbox" v-bind:checked="allChecked" v-bind:indeterminate.prop="someChecked" v-on:click="checkAllToggle">
                              <div class="control__indicator"></div>
                            </div>
                          </label>
                          <p @click="sortBy('Feature')" class="new-para" style="color:#646464;">Feature
                            <i v-show="sorting('Feature', 'up')" style="display: inline-block" class="fa fa-arrow-up"></i>
                            <i v-show="sorting('Feature', 'down')" style="display: inline-block" class="fa fa-arrow-down"></i>
                          </p>
                        </th>
                        <th>
                          <p @click="sortBy('Category')" class="non-para">Category
                            <i v-show="sorting('Category', 'up')" style="display: inline-block" class="fa fa-arrow-up"></i>
                            <i v-show="sorting('Category', 'down')" style="display: inline-block" class="fa fa-arrow-down"></i>
                          </p>
                        </th>
                        <th>
                          <p @click="sortBy('Class')" class="non-para">Class
                            <i v-show="sorting('Class', 'up')" style="display: inline-block" class="fa fa-arrow-up"></i>
                            <i v-show="sorting('Class', 'down')" style="display: inline-block" class="fa fa-arrow-down"></i>
                          </p>
                        </th>
                        <th style="padding-right: 20px !important">
                          <p @click="sortBy('Frequency')" class="non-para">Frequency
                            <i v-show="sorting('Frequency', 'up')" style="display: inline-block" class="fa fa-arrow-up"></i>
                            <i v-show="sorting('Frequency', 'down')" style="display: inline-block" class="fa fa-arrow-down"></i>
                          </p>
                        </th>
                        <th style="padding-right: 5px !important">
                          <p @click="sortBy('Occurrences')" class="non-para">Occurrences
                            <i v-show="sorting('Occurrences', 'up')" style="display: inline-block" class="fa fa-arrow-up"></i>
                            <i v-show="sorting('Occurrences', 'down')" style="display: inline-block" class="fa fa-arrow-down"></i>
                            <br> in all Classes</p>
                        </th>
                        <th class="col2">
                          <p @click="sortBy('Significance')" class="non-para">Significance
                            <i v-show="sorting('Significance', 'up')" style="display: inline-block" class="fa fa-arrow-up"></i>
                            <i v-show="sorting('Significance', 'down')" style="display: inline-block" class="fa fa-arrow-down"></i>
                            <br>(Based on T-Test)</p>
                        </th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr><td style="width: 100%; height: 45px; background-color: white" colspan="6" v-if="showSpinner"><spinner></spinner></td></tr>
                      <template v-if="!showSpinner" v-for="(feature, feature_index) in featuresToShow">
                      <!--start show this div -->
                      <tr v-if="primaryKey.name === 'Category' && ((feature_index === 0) || (feature.featureSet !== featuresToShow[feature_index-1].featureSet))" class="category-header-row" :key="'set-of-feature-' + feature_index">
                        <td style="width: 100%; height: 45px" colspan="6">
                          <div class="checkbox-div">
                            <label class="control control--checkbox" :class="{uncheck: someCheckedInSet(feature.featureSet)}">
                              <div class="chek-box-holder">
                                <input type="checkbox" v-bind:checked="allCheckedInSet(feature.featureSet)" v-bind:indeterminate.prop="someCheckedInSet(feature.featureSet)" v-on:click="checkAllInSetToggle(feature.featureSet)">
                                <div class="control__indicator"></div>
                              </div>
                              <p style="padding: 0 !important; display: inline-block !important;">{{setDisplayName[feature.featureSet]}}</p>
                            </label>
                          </div>
                        </td>
                      </tr>
                      <!--end show this div -->
                        <tr :key="feature_index">
                        <td class="col">
                          <div class="checkbox-div">
                            <label class="control control--checkbox">
                              <div class="chek-box-holder">
                                <input type="checkbox" v-on:click="toggleFeature(feature)"
                                       v-bind:checked="featuresToInclude[feature.featureSet][feature.featureName]">
                                <div class="control__indicator"></div>
                              </div>
                            </label>
                          </div>
                          <div class="feature-div">
                            <div @click="showPopup('open', feature)" class="feature-name ellipsify"
                               v-bind:title="prettyPrint(feature.featureName)">
                              {{ prettyPrint(feature.featureName) }}
                            </div>
                            <div v-if="'suppInfo' in feature" class="tooltip-holder non-dropdown-closer" style="position: relative; right: 0;">
                              <a href="#" @click="tooltipOn(feature_index)"><i class="fa fa-info-circle" aria-hidden="true"></i></a>
                              <div v-show="showTooltip === feature_index" class="tooltip" style="display: block">
                                <p>{{feature.lexprefix}}({{lexemeTypeDisp(feature.suppInfo.type)}}) {{feature.suppInfo.eng}}</p>
                              </div>
                            </div>
                            <!--<div class="tooltip-holder">-->
                              <!--<a href="#"><img src="../../assets/ic_warning.png" /></a>-->
                              <!--<div class="tooltip">-->
                                <!--<p>(Preposition) upon</p>-->
                              <!--</div>-->
                            <!--</div>-->
                          </div>
                        </td>
                        <td>{{shortestSetDisplayName(setDisplayName[feature.featureSet])}}</td>
                        <td class="ellipsify">
                          <p v-bind:title="apiNameToClass(feature.bestClass).displayName">
                            <span
                              class="bg-class"
                              :class="'bg-class-' + apiNameToNumber(feature.bestClass) % 5"
                            ></span>
                            {{apiNameToClass(feature.bestClass).displayName}}
                          </p>
                        </td>
                        <td>
                          <table v-bind:style="{'width': '100%', 'margin-bottom': '0px'}">
                            <tr v-for="(classData, index) in classes" :key="classData.id" style="background-color: inherit">
                              <td v-bind:style="{'width': '70%','padding': '2px 2px 2px 2px'}" class="ellipsify" v-bind:title="classData.displayName">{{classData.displayName}}</td>
                              <td v-bind:style="{'width': '30%', 'padding': '2px 2px 2px 2px'}" v-bind:title="feature.counts['class' + index] + ' occurrences'">{{formatFrequency(feature.averageFractions['class'+ index])}}%</td>
                            </tr>
                          </table>
                        </td>
                        <td>{{formatOccurrences(feature.counts)}}</td>
                        <td class="col2">
                          <div class="add-progressBar"><div v-bind:style="'width: ' + getSigTest(feature) + '%'"></div></div>
                        </td>
                        </tr>
                        </template>
                        <tr class="empty-class"></tr>
                      </tbody>
                    </table>
                  </div>
                </div>

              </div>
              <div class="baron__track">
                <div class="baron__bar"></div>
              </div>
            </div>
          </div>

          <div class="tab-footer">
            <form @submit="populateFeaturesToShow()" id="searchForm" class="form-holder">
              <input type="text" v-model="filter" class="form-control"/>
              <button type="button" @click="toggleFilter()" class="button hoverable bt-search"><div class="anim"></div><img v-show="filter===''" src="../../assets/ic_search_black.png"/><img v-if="filter!==''" src="../../assets/ic_cancel_small.png"></button>
            </form>
            <button
                @click="storeRemovedFeatures"
                type="button" data-toggle="modal" data-target="#remove_words_features_popup" class="button lg bg-blue pull-right hoverable"><div class="anim"></div><img src="../../assets/ic_rotate_clockwise.png"> Update</button>
          </div>
        </div>

      </div>

    </div>
  </div>

</template>
<script>
import $ from 'jquery'
import 'jquery-ui-bundle'
import 'jquery-ui-bundle/jquery-ui.css'
import {prettyPrint, lexemeSupps} from '../../mixins/featureNames'
import textMixins from '../../mixins/textMixins'
import FeatureExamples from './featureExamples.vue'
import {StateChanges} from '../../store/stateChanges'
// (now used only in downloadFunctionMixins) import _ from 'lodash'
import Spinner from '../spinner'
import infiniteScroll from 'vue-infinite-scroll'
import routeGlobals from '../../mixins/routeGlobals'

import downloadFunctionMixins from '../../mixins/downloadFunctionMixins'
// the above contains the method formatOccurrences() and the computed property strongestTTestOfClasses()

const featureSetKeys = ['dicta token', 'words', 'morphology', 'syntaxClauseTypes', 'lexemes']
const featureSetTitles = ['Disambiguated Words', 'Words', 'Morphology', 'Syntax', 'Lexemes']
let featureSetMap = new Map()
for (var i = 0; i < featureSetKeys.length; i++) {
  featureSetMap.set(featureSetKeys[i], featureSetTitles[i])
}

function gtag () { window.dataLayer.push(arguments) }

const lexemeTypes = {
  'adjv': 'Adjective',
  'advb': 'Adverb',
  'conj': 'Conjunction',
  'art': 'Article',
  'intj': 'Interjection',
  'inrg': 'Interrogative',
  'subs': 'Noun',
  'nega': 'Negative',
  'prep': 'Preposition',
  'prde': 'Demonstrative pronoun',
  'prin': 'Interrogative pronoun',
  'nmpr': 'Proper noun',
  'prps': 'Personal pronoun',
  'verb': 'Verb'
}

export default {
  name: 'editFeaturesPopup',
  components: { Spinner, FeatureExamples },
  props: ['timesopened'],
  directives: {infiniteScroll},
  data () {
    return {
      activeTab: 'words',
      allFeatureSets: [],
      activeFeatureSets: {},
      filter: '',
      focusedSet: null,
      latestFeatures: {},
      featuresToInclude: {},
      featuresToShow: [],
      allFeaturesToShow: [],
      usingInifiniteScroll: true,
      infiniteScrollProps: {
        startingSize: 50,
        increment: 50,
        currentSize: 0,
        busy: false
      },
      primaryKey: { name: 'not yet', defaultOrder: true },
      secondaryKey: { name: 'not yet', defaultOrder: true },
      chosenFeature: 'not yet',
      showNav: true,
      showTooltip: -1,
      showSpinner: false
      // myTooltip : false
    }
  },
  computed: {
    innerTimesOpened: function () {
      // console.log(this.timesopened)
      return this.timesopened
    },
    setDisplayName: function () {
      let names = {}
      featureSetMap.forEach((value, key, map) => {
        names[key] = value
      })
      // if there's some other feature set, just use the key as the display name
      this.allFeatureSets.forEach(featureSetKey => {
        if (!names.hasOwnProperty(featureSetKey)) {
          names[featureSetKey] = featureSetKey
        }
      })
      return names
    },
    allChecked: function () {
      let presume = true
      // var t0 = performance.now()
      if (this.allFeatureSets.length > 0) {
        this.allFeaturesToShow.forEach(feature => {
          // console.log(this.featuresToInclude[feature.featureSet][feature.featureName])
          if (!(this.featuresToInclude[feature.featureSet][feature.featureName])) {
            presume = false
          }
        })
      }
      // var t1 = performance.now()
      // console.log('allChecked(): ' + (t1 - t0) + ' milliseconds')
      return presume
    },
    someChecked: function () {
      let presume = false
      // var t0 = performance.now()
      if ((this.allFeatureSets.length > 0) && (!(this.allChecked))) {
        this.allFeaturesToShow.forEach(feature => {
          // console.log(this.featuresToInclude[feature.featureSet][feature.featureName])
          if (this.featuresToInclude[feature.featureSet][feature.featureName]) {
            presume = true
          }
        })
      }
      // var t1 = performance.now()
      // console.log('someChecked(): ' + (t1 - t0) + ' milliseconds')
      return presume
    },
    activeCats: function () {
      var cats = []
      Object.keys(this.activeFeatureSets).forEach(featureSetKey => {
        if (this.activeFeatureSets[featureSetKey]) {
          cats.push(this.shortestSetDisplayName(this.setDisplayName[featureSetKey]))
        }
      })
      return cats
    }
  },
  watch: {
    filter: function (newFilter) {
      this.showSpinner = true
      // this.featuresToShow = []
      this.populateFeaturesToShow()
      // this.showSpinner = false
    },
    innerTimesOpened: function (newInnerTimesOpened) {
      console.log('InnerTimesOpened: ' + newInnerTimesOpened)
      this.showSpinner = true
      // this.featuresToShow = []
      if (this.usingInifiniteScroll) {
        this.infiniteScrollProps.currentSize = this.infiniteScrollProps.startingSize
      }
      this.populateAndInitAll()
      // if (newInnerTimesOpened > 1) this.showSpinner = false
    }
  },
  mixins: [textMixins, routeGlobals, downloadFunctionMixins],
  methods: {
    prettyPrint,
    lexemeSupps,
    lexemeTypeDisp: function (lexemeType) {
      return lexemeTypes[lexemeType]
    },
    openHelpTab () { // directories defined in routeGlobals
      window.open(this.helpRootDir + this.helpPagesSubDir + 'view-edit-features.htm')
    },
    populateAndInitAll: function () {
      // var t0 = performance.now()
      this.latestFeatures = JSON.parse(JSON.stringify(this.$store.state.features))
      this.populateSets()
      this.initEditingStates()
      this.primaryKey = { name: 'Significance', defaultOrder: true }
      this.secondaryKey = { name: 'Significance', defaultOrder: true }
      this.populateFeaturesToShow()
      // var t1 = performance.now()
      // console.log('populateAndInitAll(): ' + (t1 - t0) + ' milliseconds')
    },
    sortSets: function (featureSets) {
      featureSets.sort(function (a, b) { return featureSetKeys.indexOf(a) - featureSetKeys.indexOf(b) })
    },
    populateSets: function () {
      // this.FeatureSetsToShow = ['words', 'morphology', 'syntaxClauseTypes', 'lexemes']
      const allFeatureSets = JSON.parse(JSON.stringify(Object.keys(this.$store.state.featureSettings)))
      /* if (this.allFeatureSets.length > 0) { // here we just make value needed for render exist
        this.focusedSet = allFeatureSets[0]
      } */
      this.sortSets(allFeatureSets)
      this.allFeatureSets = allFeatureSets
    },
    shortestSetDisplayName: function (displayName) {
      // return displayName.substring(0, 4)
      return displayName
    },
    populateFeaturesToShow: function () {
      // console.log('running populateFeaturesToShow()')
      var featuresToShow = []
      // var t0 = performance.now()
      this.allFeatureSets.forEach(featureSet => {
        // console.log(featureSet)
        if (this.activeFeatureSets[featureSet]) {
          this.latestFeatures[featureSet].forEach(feature => {
            if (!(this.filter) || this.matchFeatureToFilter(feature, this.filter)) {
              var featureToShowObj = {}
              Object.keys(feature).forEach(elementKey => {
                featureToShowObj[elementKey] = feature[elementKey]
              })
              featureToShowObj['featureSet'] = featureSet
              featuresToShow.push(featureToShowObj)
              if ((featureSet === 'lexemes') || (featureSet === 'dicta token')) {
                featuresToShow[featuresToShow.length - 1]['lexprefix'] = ''
                if (featureSet === 'dicta token') {
                  featuresToShow[featuresToShow.length - 1]['suppInfo'] = this.lexemeSupps(feature.featureName.split('_')[1])
                  featuresToShow[featuresToShow.length - 1]['lexprefix'] = ' ' + feature.featureName.split('_')[1].replace(/[/=[\]]/g, '').replace(/_aramaic/g, '') + ' '
                } else featuresToShow[featuresToShow.length - 1]['suppInfo'] = this.lexemeSupps(feature.featureName)
              }
            }
          })
        }
      })
      this.sortFeaturesToShow(featuresToShow)
      this.allFeaturesToShow = featuresToShow
      if (this.usingInifiniteScroll) {
        this.featuresToShow = this.allFeaturesToShow.slice(0, this.infiniteScrollProps.currentSize - 1)
      } else {
        this.featuresToShow = this.allFeaturesToShow
      }
      // var t1 = performance.now()
      // console.log('populateFeaturesToShow() [before sorting]: ' + (t1 - t0) + ' milliseconds')
    },
    loadMore () {
      this.infiniteScrollProps.busy = true
      setTimeout(() => {
        this.infiniteScrollProps.currentSize += this.infiniteScrollProps.increment
        this.featuresToShow = this.allFeaturesToShow.slice(0, this.infiniteScrollProps.currentSize - 1)
        this.infiniteScrollProps.busy = false
      }, 1)
    },
    matchFeatureToFilter (feature, filter) {
      return (feature.featureName.replace(/[\u05b0-\u05bd\u05c1\u05c2\u05c7]/g, '').toLowerCase().includes(filter.toLowerCase())) || (this.prettyPrint(feature.featureName).replace(/[\u05b0-\u05bd\u05c1\u05c2\u05c7]/g, '').toLowerCase().includes(filter.toLowerCase()))
    },
    toggleFilter () {
      if (this.filter) this.filter = ''
    },
    sortFeaturesToShow (featuresToShowTemp) {
      var sortKeys = [this.secondaryKey, this.primaryKey]
      // var t0 = performance.now()
      featuresToShowTemp.sort((a, b) => {
        return this.featureSortFunction(a, b, sortKeys)
      })
      setTimeout(() => {
        this.showSpinner = false
      }, 1)
      // var t1 = performance.now()
      // console.log('sortFeaturesToShow(): ' + (t1 - t0) + ' milliseconds')
    },
    featureSortFunction: function (feature1, feature2, originalSortKeys) {
      var func = 0
      var key
      var sortKeys = []
      originalSortKeys.forEach(originalKey => {
        sortKeys.push(originalKey)
      })
      while ((sortKeys.length > 0) && (func === 0)) {
        key = sortKeys.pop()
        if (key.name === 'Feature') {
          if (this.prettyPrint(feature1.featureName).toLowerCase() === this.prettyPrint(feature2.featureName).toLowerCase()) {
            func = 0
          } else if (this.prettyPrint(feature2.featureName).toLowerCase() < this.prettyPrint(feature1.featureName).toLowerCase()) {
            func = 1
          } else func = -1
        }
        if (key.name === 'Class') {
          func = this.apiNameToNumber(feature1.bestClass) - this.apiNameToNumber(feature2.bestClass)
        }
        if (key.name === 'Frequency') {
          func = feature2.averageFractions[feature2.bestClass] - feature1.averageFractions[feature1.bestClass]
        }
        if (key.name === 'Occurrences') {
          func = this.formatOccurrences(feature2.counts) - this.formatOccurrences(feature1.counts)
        }
        if (key.name === 'Significance') {
          func = this.getSigTest(feature2) - this.getSigTest(feature1)
        }
        if (key.name === 'Category') {
          if (this.setDisplayName[feature1.featureSet].toLowerCase() === this.setDisplayName[feature2.featureSet].toLowerCase()) {
            func = 0
          } else if (this.setDisplayName[feature2.featureSet].toLowerCase() < this.setDisplayName[feature1.featureSet].toLowerCase()) {
            func = 1
          } else func = -1
        }
        if (!(key.defaultOrder)) {
          func = -1 * func
        }
      }
      return func
    },
    sortBy (keyName) {
      this.showSpinner = true
      // console.log(this.showSpinner)
      if (keyName === this.primaryKey.name) {
        this.primaryKey.defaultOrder = !this.primaryKey.defaultOrder
      } else {
        if ((keyName === 'Class') || (keyName === 'Category')) {
          this.secondaryKey = this.primaryKey
        } else {
          this.secondaryKey = { name: keyName, defaultOrder: true }
        }
        this.primaryKey = { name: keyName, defaultOrder: true }
      }
      setTimeout(() => {
        var featuresToShowTemp = this.allFeaturesToShow
        this.sortFeaturesToShow(featuresToShowTemp)
        this.allFeaturesToShow = featuresToShowTemp
        if (this.usingInifiniteScroll) {
          this.featuresToShow = this.allFeaturesToShow.slice(0, this.infiniteScrollProps.currentSize - 1)
        } else {
          this.featuresToShow = this.allFeaturesToShow
        }
      }, 1)
    },
    sorting (keyName, dir) {
      // if ((keyName === this.primaryKey.name) || (keyName === this.secondaryKey.name)) {
      if (keyName === this.primaryKey.name) { // currently only displaying primary key
        var whichKey = ''
        if (keyName === this.primaryKey.name) {
          whichKey = 'primaryKey'
        } else {
          whichKey = 'secondaryKey'
        }
        if ((keyName === 'Feature') || (keyName === 'Category') || (keyName === 'Class')) {
          if (dir === 'up') {
            return this[whichKey].defaultOrder
          } else return !(this[whichKey].defaultOrder)
        } else {
          if (dir === 'down') {
            return this[whichKey].defaultOrder
          } else return !(this[whichKey].defaultOrder)
        }
      } else return false
    },
    formatFrequency (frequency) {
      return Math.round(frequency * 10000) / 100
    },
    initEditingStates: function () {
      const featuresToInclude = {}
      const activeFeatureSets = {}
      // var t0 = performance.now()
      this.allFeatureSets.forEach(featureSetKey => {
        featuresToInclude[featureSetKey] = {}
        this.latestFeatures[featureSetKey].forEach(feature => {
          featuresToInclude[featureSetKey][feature.featureName] = true
          if (this.$store.state.removedFeatures[featureSetKey]) {
            if (this.$store.state.removedFeatures[featureSetKey].indexOf(feature.featureName) !== -1) { // re-write?
              featuresToInclude[featureSetKey][feature.featureName] = false
            }
          }
        })
        activeFeatureSets[featureSetKey] = (this.$store.state.featureSettings[featureSetKey].active === true)
      })
      this.featuresToInclude = featuresToInclude
      this.activeFeatureSets = activeFeatureSets
      // var t1 = performance.now()
      // console.log('initEditingStates(): ' + (t1 - t0) + ' milliseconds')
      /* // from here on just tries to ensure the focusedSet is not a deactivated one, if possible
      if (!activeFeatureSets[this.focusedSet]) {
        let activeSetFound = null
        this.allFeatureSets.forEach(featureSetKey => {
          if (!activeSetFound && (featureSetKey !== this.focusedSet) && activeFeatureSets[featureSetKey]) {
            activeSetFound = featureSetKey
          }
        })
        if (activeSetFound) { this.focusedSet = activeSetFound }
      } */
    },
    showPopup: function (action, feature) {
      // Set the effect type
      var effect = 'slide'
      if (action === 'open') {
        // Set the duration (default: 400 milliseconds)
        var duration = 500
        $('#features-show').show(effect, {direction: 'right', queue: false}, duration).fadeIn({queue: false})
        $('#features-show').css({opacity: 0}).animate({opacity: 1}, 800)
        this.chosenFeature = {
          featureName: feature.featureName,
          featureType: feature.featureSet
        } // this update activates the init function in featureExamples
      } else {
      // Set the effect type
        // Set the duration (default: 400 milliseconds)
        duration = 300
        $('#features-show').hide(effect, {direction: 'right', queue: false}, duration).fadeIn({queue: false})
      }
    },
    logFeaturesToInclude () {
      console.log('this.featuresToInclude')
      console.log(this.featuresToInclude)
    },
    checkAllToggle () {
      // var t0 = performance.now()
      if (this.allFeatureSets.length > 0) {
        let prevOn = this.allChecked || this.someChecked
        this.allFeaturesToShow.forEach(feature => {
          this.featuresToInclude[feature.featureSet][feature.featureName] = !prevOn
        })
        // this.allChecked = !prevState
      }
      // var t1 = performance.now()
      // console.log('checkAllToggle(): ' + (t1 - t0) + ' milliseconds')
    },
    checkAllInSetToggle (featureSet) {
      // var t0 = performance.now()
      if (this.allFeatureSets.length > 0) {
        let prevOn = this.allCheckedInSet(featureSet) || this.someCheckedInSet(featureSet)
        this.allFeaturesToShow.forEach(feature => {
          if (feature.featureSet === featureSet) {
            this.featuresToInclude[feature.featureSet][feature.featureName] = !prevOn
          }
        })
      }
      // var t1 = performance.now()
      // console.log('checkAllInSetToggle(): ' + (t1 - t0) + ' milliseconds')
    },
    allCheckedInSet: function (featureSet) {
      // var t0 = performance.now()
      let presume = true
      if (this.allFeatureSets.length > 0) {
        this.allFeaturesToShow.forEach(feature => {
          // console.log(this.featuresToInclude[feature.featureSet][feature.featureName])
          if ((feature.featureSet === featureSet) && !(this.featuresToInclude[feature.featureSet][feature.featureName])) {
            presume = false
          }
        })
      }
      // var t1 = performance.now()
      // console.log('allCheckedInSet(): ' + (t1 - t0) + ' milliseconds')
      return presume
    },
    someCheckedInSet: function (featureSet) {
      // var t0 = performance.now()
      let presume = false
      if ((this.allFeatureSets.length > 0) && (!(this.allCheckedInSet(featureSet)))) {
        this.allFeaturesToShow.forEach(feature => {
          // console.log(this.featuresToInclude[feature.featureSet][feature.featureName])
          if ((feature.featureSet === featureSet) && (this.featuresToInclude[feature.featureSet][feature.featureName])) {
            presume = true
          }
        })
      }
      // var t1 = performance.now()
      // console.log('someCheckedInSet(): ' + (t1 - t0) + ' milliseconds')
      return presume
    },
    toggleFeature (feature) {
      let prevState = this.featuresToInclude[feature.featureSet][feature.featureName]
      this.featuresToInclude[feature.featureSet][feature.featureName] = !prevState
    },
    toggleSet (featureSetKey) {
      // console.log('ran toggleSet')
      let prevState = this.activeFeatureSets[featureSetKey]
      this.activeFeatureSets[featureSetKey] = !prevState
      this.showSpinner = true
      setTimeout(() => {
        this.populateFeaturesToShow()
      }, 1)
    },
    getSigTest (feature) {
      let sigPercent = Math.abs(feature.bestTtest) / this.strongestTTestOfClasses * 100
      return sigPercent
    },
    storeRemovedFeatures () {
      // this.showSpinner = true
      this.featuresToShow = []
      var allFeatureChanges = []
      for (let [setName, setActive] of Object.entries(this.activeFeatureSets)) {
        if (setActive !== this.$store.state.featureSettings[setName].active) {
          allFeatureChanges.push({
            object: setName,
            type: setActive ? 'ENABLE_FEATURE_SET' : 'DISABLE_FEATURE_SET'
          })
        }
        for (let [featureName, featureActive] of Object.entries(this.featuresToInclude[setName])) {
          // active is the opposite of removed, so if these are equal, we need to update the store
          if (featureActive === this.$store.state.removedFeatures[setName].includes(featureName)) {
            allFeatureChanges.push({
              object: {featureSetName: setName, featureName: featureName},
              type: featureActive ? 'ENABLE_FEATURE' : 'DISABLE_FEATURE'
            })
          }
        }
      }
      gtag('config', 'UA-103843509-5', {'page_path': 'update-features'})
      if (allFeatureChanges.length > 0) {
        this.$store.commit(StateChanges.UPDATE_FEATURES_RUNNING)
        setTimeout(() => {
          this.$store.commit(StateChanges.BATCH_FEATURE_CHANGES, allFeatureChanges)
        }, 50)
      }
    },
    tooltipOn (index) {
      // console.log('running tooltipOn() for feature #' + index)
      this.showTooltip = index
      // $('#tooltip-' + index).show()
      // $(document).click(function () { $('#tooltip-' + index).hide() })
    }
  },
  mounted: function () {
    // this.populateAndInitAll()
    $(document).on('click', '.non-dropdown-closer', function (e) {
      e.stopPropagation()
    })
    $(document).on('click', () => {
      this.showTooltip = -1
    })
    var form = document.getElementById('searchForm')
    form.addEventListener('submit', function (event) {
      event.preventDefault()
    })
  }
}

</script>
<style scoped>
  .checkbox-div {
    width: 10%;
    padding: 0;
  }
  .feature-div {
    width: 100%;
    padding-left: 10%;
    box-sizing: border-box;
  }
  .ellipsify {
    white-space: nowrap;
    position: relative;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .dimmed {
    position: relative;
  }
  .dimmed:after {
    content: " ";
    z-index: 10;
    display: block;
    position: absolute;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
  }
  .feature-tab-heading {
    display: inline-block;
    height: 24px;
    line-height: 24px;
    overflow: hidden;
    margin: 0 0 0 1px !important;
    padding: 0;
  }
  .feature-tab-checkbox {
    display: inline-block;
    height: 24px;
  }
  .feature-name {
    cursor: pointer;
    max-width: 83%;
    padding: 0;
    display: inline-block;
    vertical-align: middle;
  }
  .nav-tabs li a.tab-a {
    height: 30px !important;
    display: inline-block;
  }
  /* to keep the box-shadow over the table header*/
  .checktab {
    z-index: 10
  }
  th {
    position: sticky;
    z-index: 9;
    top: 0;
    background: white;
  }
  /* from https://stackoverflow.com/a/45042852/7200693 because border-bottom disappears when sticky */
  th:after{
    content:'';
    position:absolute;
    left: 0;
    bottom: 0;
    width:100%;
    border-bottom: solid 1px #adadad;
  }
  div.baron div#scrollable26 div.tab-content.tab-content2 div.tab-pane table tr th p.non-para{
    margin: 0;
    padding: 0 0 0 0 !important;
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
    letter-spacing: 0.2px;
    color: #646464;
  }
  /*.non-para:hover{
    text-decoration: underline;
  }*/
  .new-para:hover{
    text-decoration: unset !important;
  }
  .bt-slideDown{
    display: inline-block;
    vertical-align: top;
  }
  .bt-slideDown h3 i{
    display: inline-block;
    margin: -3px 0 0;
    font-size: 18px;
  }
  .bt-slideDown h3{
    position: relative;
    margin: 0;
  }
  .bt-slideDown h3:before{
    position: absolute;
  }
  .new-style{
    position: relative;
    z-index: 10;
    min-height: 50px;
    padding: 15px 27px 10px;
    background-color: #f6f6f6;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
  }
  .popup-new .new-style .nav-tabs{
    background: none;
    box-shadow: none;
    padding: 11px 20px 0;
    height: auto;
    border-bottom: none !important;
  }
  .popup-new .new-style .nav-tabs li{
    padding: 0 7px 0 0;
    float: left !important;
  }
  .popup-new .new-style .nav-tabs li a{
    margin: 0 !important;
    padding: 4px 6px !important;
    height: 28px !important;
    border-radius: 2px;
    line-height: inherit;
    box-sizing: border-box;
    background-color: #ffffff;
    border: solid 1px #999999 !important;
  }
  .popup-new .new-style .nav-link h3{
    height: auto;
    font-size: 16px !important;
    line-height: 20px !important;
    vertical-align: middle;
  }
  .popup-new .new-style .feature-tab-checkbox{
    height: auto;
    margin: -4px 0 0;
    vertical-align: middle;
    line-height: 16px !important;
  }
  .popup-new .new-style .nav-link li .control__indicator{
    border-radius: 2px;
  }
  .popup-new .new-style .control input:checked ~ .control__indicator{
    border-color: #007ee5;
    background-color: #007ee5;
  }
  .popup-new .new-style .control input:checked ~ .control__indicator:after{
    border-color: #fff;
  }
  .form-holder{
    width: 264px;
    height: 36px;
    float: left;
    margin: 4px 0 0;
    position: relative;
    border-radius: 2px;
    background-color: #ffffff;
  }
  .form-holder .form-control{
    width: 100%;
    border: solid 1px #999999;
    padding: 5px 40px 5px 10px;
  }
  .form-holder .bt-search{
    position: absolute;
    top: 0;
    right: 0;
    z-index: 11;
    width: 36px;
    min-width: 36px;
    background: none;
    box-shadow: none;
  }
  .new .tooltip-holder{
    text-align: left;
    margin: 0;
  }
  .new .tooltip-holder i{
    margin: 0;
    color: #646464;
    display: inline-block;
    vertical-align: middle;
  }
  .new .tooltip-holder .tooltip{
    text-align: left;
    width: 207px;
    bottom: 36px !important;
    left: -16px !important;
    padding: 8px 15px;
    border-radius: 2px;
    /*background-color: #ffffff;*/
    /*box-shadow: 0 1px 3px 0 #4c4c4c, 0 0 0 1px rgba(63, 63, 68, 0.05);*/
  }
  .new .tooltip-holder .tooltip:before {
    border-width: 9px;
    margin-left: -9px;
  }
  .new .tooltip-holder .tooltip:after {
    border-width: 8px;
    margin-left: -8px;
  }
  .new .tooltip-holder .tooltip p{padding: 0 !important;}
  /*.new .tooltip-holder .tooltip:before{display: none}*/
  /*.new .tooltip-holder .tooltip:after{*/
    /*width: 15px;*/
    /*height: 15px;*/
    /*content: '';*/
    /*position: absolute;*/
    /*background: url("../../assets/btn-angle.png") no-repeat;*/
  /*}*/
  .tab-content1 .new-list .new .addstyle p{display: inline;}
</style>



// WEBPACK FOOTER //
// src/components/experiment/editFeaturesPopup.vue